import axios from 'axios';
import getCookie from './getCookie';

export default axios.create({
  baseURL: '/api/v1/ncpl/cart',
  headers: {
    'x-ncpl-rcsrf': getCookie('x-ncpl-csrf'),
  },
});
